import SetPasswordScreen from "./SetPasswordScreen";

export default function SetNewPassword() {
  return <SetPasswordScreen mode="reset" />;
}
